
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[post]",
      function () {
        return require("private-next-pages/blogs/[post].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/[post]"])
      });
    }
  